module.exports = __webpack_public_path__ + "media/images/analytics_icons/analytic_recycled8-09498b347c0c60ecd28f9e69cfb9df5b.png";